const CustomFormat = {
    removeMoneyFormat: function (value) {
        if (value)
            return parseFloat(value.replace('R$ ', '').replace(/(\.)/g, '').replace(',', '.'));
        else
            return undefined;
    },
    toLocaleDateString: function (value) {
        if (value)
            return (new Date(value)).toLocaleDateString('pt-br', { timeZone: 'UTC' });
        else
            return undefined;
    },
    toLocaleDateTimeString: function (value) {
        if (value)
            return (new Date(value)).toLocaleString('pt-br', { timeZone: 'UTC' });
        else
            return undefined;
    },
    parseDateToFormatedString: function (value) { //De aaaa-mm-dd para dd/mm/aaaa
        if (value) {
            const [ano, mes, dia] = value.toString().split('-');
            return `${dia}/${mes}/${ano}`;
        } else {
            return undefined;
        }
    },
    parseDateToInt: function (value) { //De aaaa-mm-dd para um int aaaammdd
        if (value) {
            const [ano, mes, dia] = value.toString().split('-');
            return parseInt(ano + mes + dia);
        } else {
            return undefined;
        }
    },
    parseFormatedDateToInt: function (value) { //De dd/mm/aaaa para um int aaaammdd
        if (value) {
            const dateOnly = value.substring(0, 10);
            const [dia, mes, ano] = dateOnly.split('/');
            return parseInt(ano + mes + dia);
        } else {
            return undefined;
        }
    },
    parseFormatedDateTimeToInt: function (value) { //De 'dd/mm/aaaa hh:mm:ss' para um int aaaammddhhmmss
        if (value) {
            const dateOnly = value.substring(0, 10);
            const [dia, mes, ano] = dateOnly.split('/');
            const timeOnly = value.substring(11, 19);
            const [hora, minuto, segundo] = timeOnly.split(':');
            return parseInt(ano + mes + dia + hora + minuto + segundo);
        } else {
            return undefined;
        }
    },
    toLocaleDateTimeString: function (value) {
        if (value) {
            return (new Date(value)).toLocaleString('pt-br');
        } else {
            return undefined;
        }
    },
    removerAcentos: function (text) {
        text = text.toLowerCase();
        text = text.replace(new RegExp('[ÁÀÂÃÄ]', 'gi'), 'a');
        text = text.replace(new RegExp('[ÉÈÊË]', 'gi'), 'e');
        text = text.replace(new RegExp('[ÍÌÎÏ]', 'gi'), 'i');
        text = text.replace(new RegExp('[ÓÒÔÕÖØ]', 'gi'), 'o');
        text = text.replace(new RegExp('[ÚÙÛÜ]', 'gi'), 'u');
        text = text.replace(new RegExp('[Ç]', 'gi'), 'c');
        return text;
    },
    formatCnpjCpf: function (value) {
        const cnpjCpf = value.replace(/\D/g, '');

        if (cnpjCpf.length === 11) {
            return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3-\$4");
        }

        return cnpjCpf.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3/\$4-\$5");
    },
    compareNome: function (a, b) {
        const bandA = a.nome.toUpperCase();
        const bandB = b.nome.toUpperCase();

        let comparison = 0;
        if (bandA > bandB) {
            comparison = 1;
        } else if (bandA < bandB) {
            comparison = -1;
        }
        return comparison;
    },
}

export default CustomFormat


// WEBPACK FOOTER //
// ./src/helpers/custom-format.js